export default function Accessibility() {
  return (
    <div data-testid="accessibility-page">
      <section className="bg-navy text-white noise-overlay py-20 md:py-28">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-mono text-bronze text-sm mb-4 tracking-wider uppercase">Accessibility</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold">Accessibility Statement</h1>
        </div>
      </section>
      <section className="bg-white py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 font-body text-gray-700 space-y-6">
          <p>DA TAXGUY &amp; ASSOCIATES is committed to ensuring digital accessibility for people of all abilities. We are continually improving the user experience for everyone and applying the relevant accessibility standards.</p>
          <h2 className="font-heading text-2xl text-navy">Our Commitment</h2>
          <p>We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. This includes readable text, sufficient color contrast, keyboard navigation, and semantic markup throughout the site.</p>
          <h2 className="font-heading text-2xl text-navy">Need Assistance?</h2>
          <p>If you experience any difficulty accessing any part of this website, or need content in an alternative format, please contact us at <a href="mailto:INFO@DATAXGUY.COM" className="text-bronze underline">INFO@DATAXGUY.COM</a> or call <a href="tel:+12012537674" className="text-bronze underline">201-253-7674</a>. We will work with you to provide the information or service you need.</p>
        </div>
      </section>
    </div>
  );
}
